// extracted by mini-css-extract-plugin
export var dropdownIcon = "_pl-6";
export var imgContainer = "_pl-3";
export var menuIcon = "_pl-5";
export var pillWrapper = "_pl-2";
export var pillsContainer = "_pl-1";
export var subscriptionCard = "_pl-0";
export var subscriptionLogo = "_pl-4";